const SET_PPA_RATE = 'SET_PPA_RATE';
const SET_PPA_TERM = 'SET_PPA_TERM';
const SET_PPA_ESCALATOR = 'SET_PPA_ESCALATOR';
const SET_SHOW_PPA = 'SET_SHOW_PPA';
const SET_PPA = 'SET_PPA';

export {
    SET_PPA_RATE,
    SET_PPA_TERM,
    SET_PPA_ESCALATOR,
    SET_SHOW_PPA,
    SET_PPA,
};



// WEBPACK FOOTER //
// ./src/containers/common/ppa/constants.js